import ForgetPassword from "../../Components/ForgetPassword/ForgetPassword";

export default function ForgetPasswordPage(){
    return(
        <ForgetPassword/>
    )
}